// extracted by mini-css-extract-plugin
export var createdDate = "_fm-1";
export var divider = "_fm-2";
export var headerDivider = "_fm-3";
export var messagesCard = "_fm-0";
export var messagesContainer = "_fm-7";
export var messagesContainerWrapper = "_fm-4";
export var pointerCapturingButtonBoxes = "_fm-a";
export var showLeftPanelButton = "_fm-9";
export var showMoreButton = "_fm-c";
export var showMoreButtonContainer = "_fm-b";
export var summaryTitle = "_fm-6";
export var systemMessageCardWrapper = "_fm-d";
export var topButtons = "_fm-8";
export var withPadding = "_fm-5";